<div class="module-management">
  <!-- 工具列 -->
  <div class="toolbar">
    <div class="row align-items-center">
      <div class="col-md-6">
        <div class="search-box">
          <input
            type="text"
            class="form-control"
            placeholder="搜尋公司ID..."
            [(ngModel)]="searchTerm"
            (input)="onSearchChange()">
          <i class="fas fa-search search-icon"></i>
        </div>
      </div>
      <div class="col-md-6 text-end">
        <div class="alert alert-info mb-0">
          <i class="fas fa-info-circle me-2"></i>
          模組管理僅支援編輯現有配置
        </div>
      </div>
    </div>
  </div>

  <!-- 載入中 -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="text-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">載入中...</span>
      </div>
      <p class="mt-2">載入模組配置中...</p>
    </div>
  </div>

  <!-- 模組配置列表 -->
  <div *ngIf="!isLoading" class="module-configs-list">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>公司ID</th>
            <th>部門數量</th>
            <th>助手配置</th>
            <th>無權限顯示</th>
            <th>建立時間</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let moduleConfig of getCurrentPageItems()">
            <td>
              <span class="badge bg-primary">{{ moduleConfig.companyid }}</span>
            </td>
            <td>
              <span class="department-count">{{ moduleConfig.departments?.items?.length || 0 }} 個部門</span>
              <div class="departments-preview mt-1">
                <small class="text-muted" *ngFor="let dept of moduleConfig.departments?.items || []; let last = last">
                  {{ dept.dep_name }}{{ !last ? ', ' : '' }}
                </small>
              </div>
            </td>
            <td>
              <span class="assistant-count">{{ moduleConfig.lobby?.length || 0 }} 個助手</span>
              <div class="assistants-status mt-1">
                <small class="text-success">{{ getEnabledAssistantsCount(moduleConfig.lobby || []) }} 啟用</small>
                <small class="text-muted"> / {{ (moduleConfig.lobby?.length || 0) - getEnabledAssistantsCount(moduleConfig.lobby || []) }} 停用</small>
              </div>
            </td>
            <td>
              <span class="badge" [class]="moduleConfig.show_nopermission ? 'bg-warning' : 'bg-success'">
                {{ moduleConfig.show_nopermission ? '顯示' : '隱藏' }}
              </span>
            </td>
            <td>{{ moduleConfig.createdAt | date:'yyyy-MM-dd' }}</td>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                (click)="editModuleConfig(moduleConfig)"
                title="編輯">
                <i class="fas fa-edit me-2"></i>編輯
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 無資料提示 -->
    <div *ngIf="filteredModuleConfigs.length === 0" class="no-data">
      <div class="text-center py-4">
        <i class="fas fa-puzzle-piece fa-3x text-muted mb-3"></i>
        <h5 class="text-muted">沒有找到模組配置</h5>
        <p class="text-muted">嘗試調整搜尋條件。</p>
      </div>
    </div>

    <!-- 分頁 -->
    <div *ngIf="getTotalPages() > 1" class="pagination-container">
      <nav>
        <ul class="pagination justify-content-center">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="onPageChange(currentPage - 1)" href="#" (click)="$event.preventDefault()">上一頁</a>
          </li>
          <li *ngFor="let page of [].constructor(getTotalPages()); let i = index"
              class="page-item" [class.active]="currentPage === i + 1">
            <a class="page-link" (click)="onPageChange(i + 1)" href="#" (click)="$event.preventDefault()">{{ i + 1 }}</a>
          </li>
          <li class="page-item" [class.disabled]="currentPage === getTotalPages()">
            <a class="page-link" (click)="onPageChange(currentPage + 1)" href="#" (click)="$event.preventDefault()">下一頁</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>

<!-- 編輯模態框 -->
<div class="modal fade" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'" tabindex="-1" *ngIf="showModal">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-puzzle-piece me-2"></i>
          編輯模組配置 - {{ selectedModuleConfig?.companyid }}
        </h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="moduleForm" (ngSubmit)="saveModuleConfig()">

          <!-- 基本設定 -->
          <div class="section-header">
            <h6><i class="fas fa-cog me-2"></i>基本設定</h6>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">公司ID</label>
                <input type="text" class="form-control" formControlName="companyid" readonly>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <div class="form-check mt-4">
                  <input class="form-check-input" type="checkbox" formControlName="show_nopermission" id="showNopermission">
                  <label class="form-check-label" for="showNopermission">
                    顯示無權限項目
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="mb-3">
                <label class="form-label">部門介紹HTML *</label>
                <textarea class="form-control" formControlName="departments_introduce" rows="3"
                          placeholder='例: <div class="company-title"><h1>公司名稱 - 系統標題</h1></div>'></textarea>
              </div>
            </div>
          </div>

          <!-- 部門設定 -->
          <div class="section-header">
            <h6><i class="fas fa-building me-2"></i>部門設定</h6>
          </div>

          <div formArrayName="departments">
            <div *ngFor="let departmentGroup of departmentsFormArray.controls; let i = index"
                 [formGroupName]="i" class="department-item">
              <div class="department-header">
                <h6>部門 {{ i + 1 }}</h6>
                <button
                  type="button"
                  class="btn btn-outline-danger btn-sm"
                  (click)="removeDepartmentFormGroup(i)"
                  [disabled]="departmentsFormArray.length === 1"
                  title="刪除部門">
                  <i class="fas fa-trash"></i>
                </button>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label">部門ID *</label>
                    <input type="text" class="form-control" formControlName="dep_id" readonly>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label">部門名稱 *</label>
                    <input type="text" class="form-control" formControlName="dep_name" placeholder="例: ESH">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">部門圖片URL *</label>
                    <input type="text" class="form-control" formControlName="dep_image_url"
                           placeholder="assets/images/dept.png">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">部門描述 *</label>
                    <input type="text" class="form-control" formControlName="dep_content"
                           placeholder="例: 職業安全衛生部門">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-end mb-4">
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="addDepartmentFormGroup()">
              <i class="fas fa-plus me-2"></i>新增部門
            </button>
          </div>

          <!-- 助手設定 -->
          <div class="section-header">
            <h6><i class="fas fa-robot me-2"></i>助手設定</h6>
          </div>

          <div formArrayName="lobby">
            <div *ngFor="let assistantGroup of lobbyFormArray.controls; let i = index"
                 [formGroupName]="i" class="assistant-item">
              <div class="assistant-header">
                <h6>助手 {{ i + 1 }}</h6>
                <button
                  type="button"
                  class="btn btn-outline-danger btn-sm"
                  (click)="removeLobbyFormGroup(i)"
                  [disabled]="lobbyFormArray.length === 1"
                  title="刪除助手">
                  <i class="fas fa-trash"></i>
                </button>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">助手編號 *</label>
                    <input type="text" class="form-control" formControlName="assistantNo"
                           placeholder="例: asst_xxxxxxxxxx">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">助手標題 *</label>
                    <input type="text" class="form-control" formControlName="title"
                           placeholder="例: 自動檢查 AI Assistant">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">狀態</label>
                    <select class="form-select" formControlName="enable">
                      <option [value]="true">啟用</option>
                      <option [value]="false">停用</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">助手描述 *</label>
                    <input type="text" class="form-control" formControlName="content"
                           placeholder="例: For Taiwan Standard">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-end">
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="addLobbyFormGroup()">
              <i class="fas fa-plus me-2"></i>新增助手
            </button>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">取消</button>
        <button type="button" class="btn btn-primary" (click)="saveModuleConfig()" [disabled]="!moduleForm.valid">
          <i class="fas fa-save me-2"></i>更新配置
        </button>
      </div>
    </div>
  </div>
</div>

<!-- 模態框背景 -->
<div class="modal-backdrop fade" [class.show]="showModal" *ngIf="showModal"></div>
